export const NEW_GROUP = 'مجموعة جديدة';
export const GROUP_NAME = 'إسم المجموعة ...';
export const ENTER_JOIN_CODE = 'أدخل رمز الإنضمام';
export const ADD_TASK = ' اضافة تكليف ';
export const EDIT_TASK = 'تحرير تكليف';
export const TITLE = 'العنوان';
export const DUE = 'الموعد النهائي';
export const DESCRIPTION = 'الوصف';
export const SUBMISSION = 'تسليم';
export const NO_PERMISSION = 'لا يمكن اتمام العملية لعدم وجود صلاحية';
export const CONTACT_PERMISSION = 'الرجاء منح صلاحية الدخول الى قائمة الأسماء من أجل اتمام العملية';
export const NO_CONTACT = 'لم يتم العثور على جهات اتصال';
export const CONTACTS = 'قائمة العناوين';
export const SELECTED = num => `تم تحديد ${num}`;
export const SHARE = 'مشاركة';
export const SEARCH = 'بحث';
export const PROFILE = 'الملف التعريفي';
export const CAMERA = 'كاميرا';
export const PHOTOS_VIDEOS = 'صور و فيديوهات';
export const DOCUMENTS = 'مستند';
export const POLL = 'سحب';
export const LOCATION = 'موقع';
export const CONTACT = 'عنوان';
export const ATTACHMENTS = 'مرفقات';
export const ADD_ATTACHMENT = 'اضافة مرفقات';
export const SEND_LOCATION = 'أرسل الموقع';
export const LOCATION_PERMISSION = 'الرجاء منح صلاحية الدخول الى موقع الجهاز من أجل اتمام العملية';
export const UNBLOCK = 'إلغاء الحظر';
export const BLOCK_LIST = 'قائمة الحظر';
export const REASON = 'السبب';
export const OPTIONAL = 'اختياري';
export const BLOCK_FROM_GROUP = 'حظر من المجموعة';
export const REPORT_MEMBER = 'الإبلاغ عن العضو';
export const DONE = 'انتهى';
export const SEXUAL_CONTENT = 'محتوى إباحي';
export const VIOLENT_CONTENT = 'محتوى عنيف';
export const SPAM = 'بريد مؤذي';
export const SUBMISSIONS = 'التسليمات';
export const MEMBERS_INFO = `معلومات العضو`;
export const TIME = 'الوقت';
export const MEDIA = 'الوسائط';



// WEBPACK FOOTER //
// ./src/lang/ar/modal.js